import {register} from '@shopify/theme-sections';

import initShopTheLook from '../components/shop-the-look';

export default register('image-columns', {
  onLoad() {
    initShopTheLook(this.container);
  },
});
